import React, { useEffect, useMemo } from 'react';
import { IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

const AGGridHeader = (props) => {
  const [sortDirection, setSortDirection] = React.useState(props.column.getSort());
  const [hasActiveFilter, setHasActiveFilter] = React.useState(props.column.isFilterActive());
  const allowsFiltering = useMemo(() => !!props.column.getColDef().filter, [props]);

  useEffect(() => {
    const onSortChanged = () => {
      setSortDirection(props.column.getSort());
    };

    const onFilterChanged = () => {
      setHasActiveFilter(props.column.isFilterActive());
    };

    props.api.addEventListener('sortChanged', onSortChanged);
    props.api.addEventListener('filterChanged', onFilterChanged);

    return () => {
      props.api.removeEventListener('sortChanged', onSortChanged);
      props.api.removeEventListener('filterChanged', onFilterChanged);
    };
  }, []);

  const onFilterClick = (event) => {
    const colDef = props.column.getColDef();
    colDef.menuTabs = ['filterMenuTab'];
    props.api.showColumnMenuAfterButtonClick(props.column, event.currentTarget);
  };

  const onMenuClick = (event) => {
    const colDef = props.column.getColDef();
    colDef.menuTabs = ['generalMenuTab', 'columnsMenuTab'];
    props.api.showColumnMenuAfterButtonClick(props.column, event.currentTarget);
  };

  const onSortRequested = (event) => {
    if (props.enableSorting) {
      props.progressSort(event.shiftKey);
      setSortDirection(props.column.getSort());
    }
  };

  const getSortIcon = () => {
    if (!props.enableSorting) {
      return null;
    }

    const iconStyle = {
      fontSize: '16px',
      marginLeft: '6px',
      verticalAlign: 'middle'
    };

    if (sortDirection === 'asc') {
      return <ArrowUpwardIcon style={iconStyle} />;
    }

    if (sortDirection === 'desc') {
      return <ArrowDownwardIcon style={iconStyle} />;
    }

    return <UnfoldMoreIcon style={iconStyle} color="action" />;
  };

  return (
    <div
      className="custom-header"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: '0 4px'
      }}
    >
      <div>
        <span
          onClick={onSortRequested}
          style={{ cursor: props.enableSorting ? 'pointer' : 'default' }}
        >
          {props.displayName}
        </span>
        {getSortIcon()}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {allowsFiltering && (
          <IconButton
            size="small"
            onClick={onFilterClick}
            sx={{ backgroundColor: hasActiveFilter ? 'action.hover' : 'transparent' }}
          >
            <FilterListIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton size="small" onClick={onMenuClick}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};

export default AGGridHeader;
